export interface Config {
  apiEndpoint: string;
  environment: string;
  heapsGoAdminUrl: string;
}

export const config: Config = {
  apiEndpoint: process.env.REACT_APP_API_ENDPOINT!,
  environment: process.env.REACT_APP_ENVIRONMENT!,
  // The new admin (heapsgo-admin-web). Anything but production links to the
  // staging admin.
  heapsGoAdminUrl:
    process.env.REACT_APP_ENVIRONMENT === "production"
      ? "https://admin.heapsgo.com"
      : "https://admin-staging.heapsgo.com",
};
